export default "<input type=\"text\" class=\"datepicker\" #datepicker>\n"